import { createApp } from "vue";
import App from "./App.vue";

// import Aos Library
import "aos/dist/aos.css";

// main style
import "@/assets/style/main.scss";

createApp(App).mount("#app");
